import React from 'react';
import { CloseButton } from '@components/close-button';
import { IconPencil } from '@components/icons';
import classNames from 'classnames';

import { ModalStickyHeaderProps } from './modal-sticky-header.type';

export const ModalStickyHeader = ({
  titleDataTestId,
  primaryIcon,
  secondaryIcon,
  primaryIconClassName,
  primaryIconColor,
  customRightElement,
  isDisabledSecondaryIcon,
  title,
  titleSuffix,
  editDataTestId,
  closeDataTestId,
  variant = 'md',
  textColorClass = 'text-primary',
  bordered,
  onClickPrimaryIcon,
  onClickSecondaryIcon,
  onClickEditTitle,
  handleClose,
}: ModalStickyHeaderProps) => {
  const PrimaryIcon = primaryIcon;
  const SecondaryIcon = secondaryIcon;

  return (
    <header
      data-testid={titleDataTestId}
      className={classNames(
        'sticky top-0 w-full z-20 flex bg-primary flex-row justify-between items-center px-6 py-6 gap-x-2',
        {
          'sm:shadow-custom': bordered,
        }
      )}>
      <div className='flex flex-row items-center gap-2'>
        {PrimaryIcon && (
          <button
            type='button'
            onClick={onClickPrimaryIcon}
            className={classNames(
              'flex justify-center items-center rounded-md max-h-7.5 max-w-7.5 sm:max-h-full sm:max-w-none',
              primaryIconClassName,
              { 'cursor-default': !onClickPrimaryIcon }
            )}
            style={{ backgroundColor: primaryIconColor }}>
            <PrimaryIcon className='w-8 h-8 text-white mix-blend-difference' />
          </button>
        )}
        <h3
          className={classNames(
            'text-primary text-left grow ',
            {
              'text-headline-xs md:text-headline-s': variant === 'sm',
              'text-headline-s md:text-headline-m': variant === 'md',
              'text-headline-m md:text-headline-l': variant === 'lg',
            },
            textColorClass
          )}>
          {title}
        </h3>
        {titleSuffix}
        {onClickEditTitle && (
          <button type='button' onClick={onClickEditTitle} data-testid={editDataTestId}>
            <IconPencil className='text-primary h-4.5 w-4.5' />
          </button>
        )}
        {SecondaryIcon && (
          <button type='button' onClick={onClickSecondaryIcon} disabled={isDisabledSecondaryIcon}>
            <SecondaryIcon className='text-primary bg-secondary w-3.5' />
          </button>
        )}
      </div>

      {handleClose && <CloseButton id={closeDataTestId} handleClose={handleClose} dataTestId={closeDataTestId} />}
      {customRightElement && customRightElement}
    </header>
  );
};
